import React from 'react'
import InnerBanner from './InnerBanner';
import AnantFarms from './AnantFarms'

const RoadTrip = ()=>{
    return(
        <div>
          <InnerBanner />
          <AnantFarms />
         

        </div>
    )
}

export default RoadTrip;